<template>
  <section class="product-list-container">
    <dl class="product-list-wrapper">
      <dd class="item" v-for="(item,index) in list" :key="index" :class="[colClass]">
        <div
          class="item-area"
          :class="{'isSelected': isSelected, 'isRank': isRank, 'soldOut': item.lowerShelfStatus!=='0'}"
        >
          <!-- 排行榜头标 -->
          <div
            class="ranking"
            :class="[index<=2 ? 'rank-'+(index+1):'rank-4']"
            v-if="isRank"
          >{{index<=2 ? '':(index+1)}}</div>
          <!-- 多选checkbox -->
          <label class="check-item" v-if="isChecked">
            <input type="checkbox" name="selectitem" :value="item.id" v-model="selectValue" />
            <span class="icon"></span>
          </label>

          <div class="item-content" @click="handleToDetail(item)">
            <div class="img-wrapper">
              <span class="tag" v-if="item.is_subsidize === '1'"><i></i></span>
              <div class="img-box">
                <img v-lazy="item.our_image" alt v-if="item.our_image" />
                <img v-lazy="item.image" alt v-else />
              </div>
            </div>
            <div class="inner">
              <div>
                <p
                  class="title"
                  :class="[isRank || isSelected ? 'ellipsis-2':'ellipsis-1']"
                >{{item.title}}</p>
                <div
                  class="desc ellipsis-2"
                  v-if="isRank && !isCourse(item.type)"
                  v-html="item.intro"
                ></div>
              </div>
              <div class="info">
                <template v-if="isSelected">
                  <div style="width: 100%;flex:1;">
                    <div class="bt-money" v-if="item.is_subsidize === '1'">
                      <span class="icon">
                        <i></i>
                      </span>
                      <div class="txt">
                        <span class="sm">¥</span>
                        <nr-amount :value="item.extra_subsidy_price" />
                      </div>
                    </div>

                    <div class="rise" v-if="item.isUseCoiling === '1' && item.isHasActivity==='1'">
                      <i class="iconfont icon-ticket"></i>
                      +{{item.extra_distribution_proportion*100}}%
                    </div>
                    <div class="selected-info">
                      <div class="price-box ellipsis-1">
                        已获佣金
                        <p class="price">
                          <span class="small">¥</span>
                          <nr-amount :value="item.total_distribution_price" class="num" />
                        </p>
                      </div>
                      <p class="people ellipsis-1">
                        已卖出
                        <span class="strong">{{countUnit(item.deal_indent_count)}}</span>
                      </p>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <template v-if="isCourse(item.type)">
                    <div class="price-box ellipsis-1">
                      预估佣金
                      <p class="price">
                        ¥
                        <span class="num">
                          <nr-amount
                            :value="(item.commission_money ? item.commission_money : (item.price * item.media_distribution_proportion)) "
                          />
                        </span>
                      </p>
                    </div>
                  </template>
                  <div class="price-box ellipsis-1" v-else>
                    佣金比例
                    <p class="price">
                      <span
                        class="num"
                      >{{ item.media_distribution_proportion ? round(item.media_distribution_proportion*100): 0}}%</span>
                    </p>
                  </div>
                  <!-- <p class="people ellipsis-1" v-if="item.platform_sell_count && item.platform_sell_count!=='0'">{{item.platform_sell_count | tranNumber}}{{isCourse(item.type,true) ?'人学习':'人购买'}}</p> -->
                </template>
              </div>
            </div>
          </div>

          <span class="icon-sold-out"></span>
        </div>
      </dd>
    </dl>
    <Empty iconType="2" title="暂无数据" v-if="!list.length && !loading" />
  </section>
</template>

<script>
import { round, countUnit } from "@/utils";

export default {
  data() {
    return {
      selectValue: [],
    };
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    colClass: {
      type: String,
      default: "col-2",
      validator: function (value) {
        return (
          ["col-1", "col-1 faction", "col-2", "col-3"].indexOf(value) !== -1
        );
      },
    },
    isRank: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
    isNewWindow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    round,
    countUnit,
    //去详情
    handleToDetail(item) {
      if (this.isSelected && item.lowerShelfStatus !== "0") return;

      let id = this.isSelected ? item.source_record_id : item.id;

      if (!this.isNewWindow) {
        this.$router.push({
          name: "detail",
          params: {
            id: id,
          },
        });
      } else {
        let { href } = this.$router.resolve({
          name: "detail",
          params: {
            id: id,
          },
        });

        let newWindow = window.open("_blank");
        newWindow.location = href;
      }
    },
    // 清空已选择 item
    clearSelectValue() {
      this.selectValue = [];
    },
    //返回已选择 item
    getSelectValue() {
      return this.selectValue;
    },
  },
};
</script>

<style lang="scss">
.product-list-container {
  position: relative;
  min-height: 200px;
}
.product-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 13px;
  box-sizing: border-box;

  .item-area {
    position: relative;

    &.isSelected {
      align-items: center;
    }
  }
  .ranking {
    width: 42px;
    margin-right: 32px;
    background-size: 42px 46px;
    background-repeat: no-repeat;
    flex-shrink: 0;
    background-position-y: 2px;

    &.rank-1 {
      background-image: url("../../../assets/imgs/icon_rank_1.svg");
    }
    &.rank-2 {
      background-image: url("../../../assets/imgs/icon_rank_2.svg");
    }
    &.rank-3 {
      background-image: url("../../../assets/imgs/icon_rank_3.svg");
    }
    &.rank-4 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 32px;
      padding-bottom: 4px;
      background-position: center;
      box-sizing: border-box;
      background-image: url("../../../assets/imgs/icon_rank_4.svg");
      background-size: 30px 32px;
      font-size: 24px;
      color: #fff;
    }
  }
  .check-item {
    width: 32px;
    height: 32px;
    margin-right: 30px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    .icon {
      display: block;
      width: 100%;
      height: 100%;
      border: 1px solid #e1e2e5;
      border-radius: 50%;
      box-sizing: border-box;
    }
    input {
      font-size: 300%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;

      &:checked + .icon {
        border: none;
        background: url("../../../assets/imgs/icon_selected.svg") no-repeat center;
        background-size: 100%;
      }
    }
  }
  .img-wrapper {
    width: 100%;
    padding-bottom: calc(100% / 1.75);
    position: relative;

    .tag{
      position: absolute;
      top: 0;
      left: 8px;
      padding: 0 10px;
      height: 36px;
      border-radius:  0 0 8px 8px;
      background: linear-gradient(128deg, #D9B468 0%, #EFDAB0 100%);
      z-index: 2;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      i{
        width: 48px;
        height: 20px;
        background: url('../imgs/bt.svg') no-repeat;
        background-size: contain;
      }
    }
  }
  .img-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
    background-color: $border-color-base;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;

      &[lazy="loading"],
      &[lazy="error"] {
        object-fit: contain;
      }
    }
  }
  .inner {
    margin-top: 24px;

    .title {
      height: 68px;
      color: $heading-color;
      font-size: 26px;
      line-height: 34px;

      &.ellipsis-1 {
        height: 34px;
      }
    }
    .desc {
      font-size: 24px;
      line-height: 32px;
      color: $text-color;
      margin-top: 40px;
      max-height: 64px;
      overflow: hidden;
    }
    .info {
      margin-top: 32px;
    }
    .price-box {
      display: flex;
      align-items: flex-end;
      color: $text-color;
      font-size: 24px;
    }
    .price {
      font-size: 28px;
      color: $price-color;
      font-weight: bold;
      margin-left: 20px;

      .small {
        font-size: 20px;
      }
    }
    .num {
      display: inline-block;
      margin-left: 2px;
    }
    .people {
      margin-top: 20px;
      font-size: 24px;
      color: $text-color-secondary;
    }
  }
  .item {
    padding: 0 13px;
    box-sizing: border-box;
    margin-bottom: 40px;

    .icon-sold-out {
      position: absolute;
      right: -24px;
      width: 140px;
      height: 184px;
      background: url("../../../assets/imgs/img_sold_out.svg") no-repeat;
      background-size: cover;
      display: none;
      z-index: 2;
    }
    &.col-1 {
      width: 100%;

      .item-area {
        display: flex;

        &.isSelected {
          .people {
            color: $text-color;
          }
          .strong {
            font-weight: bold;
            margin-left: 8px;
          }
          &.soldOut {
            .item-content {
              &:after {
                content: "";
                background: rgba(255, 255, 255, 0.7);
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
              }
            }
            .icon-sold-out {
              display: inline-block;
            }
          }
        }
      }
      .item-content {
        flex: 1;
        display: flex;
        flex-direction: row;
        transition: all 0.3s;
        position: relative;
      }
      .img-wrapper {
        width: calc(1.5rem * 1.75);
        padding-bottom: 1.5rem;

        &.faction {
          width: 1.8rem;
          padding-bottom: calc(1.8rem * 1.4);
        }
      }
      .title {
        height: auto;
      }
      .inner {
        margin-top: 0;
        margin-left: 24px;
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .bt-money{
        display: inline-flex;
        align-items: stretch;
        margin-bottom: 8px;
        color: #DDBB76;

        .icon{
          width: 60px;
          background: linear-gradient(52deg, #D9B468 0%, #EFDAB0 100%);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-top-left-radius: 8px;

          i{
            display: inline-block;
            width: 48px;
            height: 20px;
            background: url('../imgs/bt.svg') no-repeat;
            background-size: contain;
          }
        }
        .txt{
          height: 100%;
          line-height: 36px;
          border: 1px solid #DDBB76;
          box-sizing: border-box;
          border-left: none;
          border-radius: 0 8px 8px 0;
          padding: 0 6px;
          font-size: 22px;
        }
        .strong{
          font-weight: bold;
          font-size: 24px;
          line-height: 1;
        }
        .nr-amount{
          font-weight: bold;
        }
      }
      .rise {
        font-size: 40px;
        color: $price-color;
        background: rgba(255, 51, 51, 0.1);
        height: 36px;
        line-height: 32px;
        display: inline-block;
        padding: 0 40px;
        font-weight: bold;
        border-radius: 40px;
        margin-bottom: 32px;

        .iconfont {
          font-weight: normal;
          margin-right: 8px;
          font-size: 24px;
          position: relative;
          top: 1px;
        }
      }
      .selected-info {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }
      .price-box {
        flex-shrink: 0;
      }
      .people {
        margin-top: 0;
      }
    }
    &.col-2 {
      width: 50%;
      margin-bottom: 60px;

      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .price-box {
        flex-shrink: 0;
        margin-right: 30px;
      }
      .people {
        margin-top: 0;
      }
    }
    &.col-3 {
      width: 33.33333%;
      margin-bottom: 60px;

      .img-wrapper {
        padding-bottom: calc(100% * 1.4);
      }
    }
    &.faction {
      .img-wrapper {
        width: 1.8rem;
        padding-bottom: calc(1.8rem * 1.4);
      }
    }
  }
}
</style>